<ds-panel [toggleable]="true" (onAfterToggle)="togglePanelFiltry = !togglePanelFiltry">
  <ds-panel-header> Filtry </ds-panel-header>
  <div [ngStyle]="{'visibility': togglePanelFiltry ? 'visible' : 'hidden'}">
    <form class="filter-form" [formGroup]="form">
      <div class="p-grid p-ai-end p-ai-xl-start w-100">
        <div class="p-col-12 p-md-6 p-xl-2">
          <ds-calendar label="Data zdarzenia od" [showOtherMonths]="false" [selectOtherMonths]="false" iconRight="pi-calendar"
                       [iconRightTitle]="'Wybierz datę'" formControlName="registrationFrom"></ds-calendar>
        </div>
        <div class="p-col-12 p-md-6 p-xl-2">
          <ds-calendar label="Data zdarzenia do" [showOtherMonths]="false" [selectOtherMonths]="false" iconRight="pi-calendar"
                       [iconRightTitle]="'Wybierz datę'" formControlName="registrationTo" [minDate]="dataZdarzeniaDoMin"></ds-calendar>
        </div>
        <div class="p-col-12 p-md-6 p-xl-2">
          <ds-krs label="Numer KRS" formControlName="krs" placeholder="__________"></ds-krs>
        </div>
        <div class="p-col-12 p-md-6 p-xl-3">
          <ds-input label="Nazwa" formControlName="subjectName"></ds-input>
        </div>
        <div class="p-col-12 p-md-6 p-xl-3">
          <ds-dropdown
            formControlName="type"
            [options]="typZdarzenia"
            [optionLabel]="'name'"
            [valueField]="'value'"
            [autoDisplayFirst]="true"
            label="Typ zdarzenia"
          ></ds-dropdown>
        </div>
        <div class="p-col-12 p-md-6 p-xl-3">
          <ds-checkbox label="Pokaż także usunięte" formControlName="showAll"></ds-checkbox>
        </div>
        <div class="p-col-6 p-md-3 p-xl-1 p-xl-offset-6 p-md-offset-6 button-container">
          <ds-button severity="border"
            (onClick)="clear()"
            label="Wyczyść"
            [disabled]="dataFilterService.loading$ | async"
          ></ds-button>
        </div>
        <div class="p-col-6 p-md-3 p-xl-2 button-container">
          <ds-button severity="primary"
                     type="submit"
                     label="Filtruj"
                     (onClick)="filter()"
                     [disabled]="dataFilterService.loading$ | async"
                     ></ds-button>
        </div>
      </div>
    </form>
  </div>
</ds-panel>
